import { z } from 'zod'
import type { FormatInstitution } from '@/types/formatInstitution.ts'
import { optionalExternalUrlSchema } from '@/validation/schemas/common'

export const FormatInstitutionSchema: z.ZodType<Partial<FormatInstitution>> = z.looseObject({
    name: z.string().trim().min(1, { message: 'ui.institutions.validation.emptyName' }),
    function: z.enum(
        ['ORGANIZED_BY', 'CONDUCTED_BY', 'COOPERATING_WITH', 'PART_OF', 'FUNDED_BY', 'FUNDED_FROM'],
        { message: 'ui.institutions.validation.emptyFunction' }
    ),
    url: optionalExternalUrlSchema,
    logo: z.any().refine((value) => !!value, { message: 'ui.institutions.validation.emptyLogo' }),
}) as z.ZodType<Partial<FormatInstitution>>
